<template>
  <v-dialog v-model="show" max-width="500">
    <v-form ref="groupForm" v-model="valid">
      <v-card
        :dark="$store.getters.getColorPalette().isDark"
        :color="$store.getters.getColorPalette().backgroundColorCode"
      >
        <v-card-text>
          <v-select
            v-model="type"
            :items="typeOptions"
            :label="$store.getters.getTextMap().type"
            outlined
            item-text="label"
            item-value="value"
            required
            :menu-props="{ dark: $store.getters.getColorPalette().isDark }"
            :rules="objectRules"
          ></v-select>
          <v-select
            v-if="type === 'input'"
            placeholder="Field Type"
            v-model="field_type"
            :rules="objectRules"
            :items="fieldTypeOptions"
            item-text="label"
            item-value="value"
            outlined
            dense
          ></v-select>
          <v-text-field
            v-else
            v-model="text"
            :counter="500"
            :rules="nameRules"
            :label="$store.getters.getTextMap().value"
            required
          ></v-text-field>
          <v-select
            v-if="field_type === 'list_text' && type === 'input'"
            placeholder="Select List"
            v-model="list_id"
            :items="lists"
            item-text="label"
            item-value="value"
            outlined
            dense
          >
          </v-select>
          Validations (Optional)
          <v-row class="mt-2" v-if="!validation_rules.length > 0">
            <v-col>
              <v-select
                v-if="!loading"
                placeholder="Condition Type"
                v-model="validation_condition_type"
                :items="conditionTypeOptions"
                item-text="label"
                item-value="value"
                outlined
                dense
              >
              </v-select>
            </v-col>
          </v-row>
          <v-row class="mt-2" no-gutters>
            <v-col class="mr-2">
              <v-select
                v-if="!loading"
                placeholder="Type"
                v-model="validation_field_type"
                :items="validationFieldType"
                item-text="label"
                item-value="value"
                outlined
                dense
              >
              </v-select>
            </v-col>
            <v-col class="mr-2">
              <v-select
                v-if="!loading"
                placeholder="Operator"
                v-model="operator"
                :items="operators"
                item-text="label"
                item-value="value"
                outlined
                dense
              >
              </v-select>
            </v-col>
            <v-col class="mr-2">
              <v-text-field
                v-if="!loading"
                placeholder="Operand"
                v-model="operand"
                outlined
                dense
              >
              </v-text-field>
            </v-col>
            <v-col class="mr-2">
              <v-skeleton-loader
                v-if="loading"
                class="mx-auto"
                type="text"
              ></v-skeleton-loader>
              <v-btn
                v-if="!loading"
                text
                outlined
                :color="$store.getters.getColorPalette().submitbtnColor"
                @click="addValidationToList()"
                >Add Validation</v-btn
              >
            </v-col>
          </v-row>
          <v-row
            class="mb-5"
            no-gutters
            v-if="validation_rules && validation_rules.length > 0"
          >
            <v-col>
              <span v-for="(rule, ind) in validation_rules" :key="ind">{{
                `${rule.validation_field_type} ${rule.operator} ${rule.operand} ${validation_condition_type} `
              }}</span>
              <v-btn
                small
                text
                outlined
                :color="$store.getters.getColorPalette().cancelbtnColor"
                @click="validation_rules = []"
                class="ml-3"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-col>
            <v-col> </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            :color="$store.getters.getColorPalette().submitbtnColor"
            text
            @click="onSubmit"
          >
            {{ $store.getters.getTextMap().submit }}
          </v-btn>
          <v-btn
            :color="$store.getters.getColorPalette().submitbtnColor"
            text
            @click="onReset"
          >
            {{ $store.getters.getTextMap().cancel }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>
<script>
export default {
  name: "GetChecklistFieldModal",
  props: ["show", "name"],
  data() {
    return {
      type: "static",
      text: null,
      valid: false,
      loading: false,
      field_type: null,
      list_id: null,
      operator: null,
      operand: null,
      validation_rules: [],
      validation_condition_type: "&",
      validation_field_type: "text",
      error_text: "Field is not valid",
      validation_type: "and",
      validationFieldType: [
        { label: "Text", value: "text" },
        { label: "Number", value: "number" },
      ],
      operators: [
        { label: "Greater than", value: ">" },
        { label: "Modulus Greater than", value: "|>" },
        { label: "Lesser than", value: "<" },
        { label: "Modulus Lesser than", value: "|<" },
        { label: "Equals to", value: "==" },
        { label: "Not Equal to", value: "!=" },
        { label: "Modulus Equals to", value: "|==" },
        { label: "Greater than equal to", value: ">=" },
        { label: "Modulus Greater than equal to", value: "|>=" },
        { label: "Lesser than equal to", value: "<=" },
        { label: "Modulus Lesser than equal to", value: "|<=" },
      ],
      conditionTypeOptions: [
        { label: "And", value: "&" },
        { label: "Or", value: "|" },
      ],
      typeOptions: [
        { label: "Static", value: "static" },
        { label: "Input", value: "input" },
      ],
      fieldTypeOptions: [
        {
          label: "Text",
          value: "text",
        },
        {
          label: "Text from Dropdown",
          value: "list_text",
        },
        {
          label: "Check",
          value: "check",
        },
        {
          label: "Calendar",
          value: "calendar",
        },
        {
          label: "Clock",
          value: "clock",
        },
        // {
        //     label: "Image",
        //     value: 'image'
        // },
        {
          label: "QR Code",
          value: "qrtext",
        },
        {
          label: "Image to Text Conversion",
          value: "ocr",
        },
      ],
      nameRules: [
        (v) => !!v || "required",
        (v) => /\S+/.test(v) || "Text only",
        (v) =>
          (v && v.length <= 500 && v.length > 0) ||
          "Name must be less than 501 characters",
      ],
      objectRules: [(v) => !!v || "Required"],
    };
  },
  mounted() {
    if (this.name) {
      this.text = this.name;
    }
  },
  computed: {
    lists() {
      let op = [];
      for (let i of this.$store.state.lists) {
        op.push({ label: i.name, value: i.list_id });
      }
      return op;
    },
  },
  methods: {
    addValidationToList() {
      let temp;
      if (this.operator && this.operand && this.validation_field_type) {
        temp = {
          operator: this.operator,
          operand: this.operand,
          validation_field_type: this.validation_field_type,
          validCond: this.validation_condition_type,
          error_text: this.error_text,
        };
      }
      this.validation_rules.push(temp);
      this.operator = null;
      this.operand = null;
      this.validation_field_type = null;
    },
    onSubmit() {
      this.$refs.groupForm.validate();
      if (this.valid) {
        let returnValue = {};
        if (this.type === "static") {
          returnValue["type"] = this.type;
          returnValue["value"] = this.text;
        } else {
          returnValue["type"] = this.type;
          let temp = {};
          temp["meta"] = {};
          temp["meta"]["validation_rules"] = this.validation_rules;
          switch (this.field_type) {
            case "text":
              temp["type"] = this.field_type;
              temp["data"] = null;
              break;
            case "list_text":
              temp["type"] = this.field_type;
              temp["data"] = null;
              temp["meta"]["list_id"] = this.list_id;
              this.list_id = null;
              break;
            case "check":
              temp["type"] = this.field_type;
              temp["data"] = false;
              break;
            case "calendar":
              temp["type"] = this.field_type;
              temp["data"] = null;
              break;
            case "clock":
              temp["type"] = this.field_type;
              temp["data"] = null;
              break;
            case "image":
              temp["type"] = this.field_type;
              temp["data"] = false;
              break;
            case "qrtext":
              temp["type"] = this.field_type;
              temp["data"] = null;
              break;
            case "ocr":
              temp["type"] = this.field_type;
              temp["data"] = null;
              break;
          }
          returnValue["value"] = temp;
        }

        this.validation_rules = [];
        this.$emit("value", returnValue);
        this.$emit("close");
      }
    },
    onReset() {
      this.$emit("close");
    },
  },
  watch: {
    name: {
      handler() {
        this.text = this.name;
      },
      deep: true,
    },
  },
};
</script>
